import request from '@/utils/request'

const key = 'role'

// 查询角色
export function fetchUserRole(params) {
  return request({
    url: `/platform/${key}`,
    method: 'get',
    params
  })
}

// 查询角色详情
export function fetchUserRoleDetail(id) {
  return request({
    url: `/platform/${key}/${id}`,
    method: 'get'
  })
}

// 添加
export function createUserRole(data) {
  return request({
    url: `/platform/${key}`,
    method: 'post',
    data
  })
}

// 编辑角色
export function updateRole(id, data) {
  return request({
    url: `/platform/${key}/${id}`,
    method: 'post',
    data
  })
}

// 编辑角色
export function fetchAllMenu(params) {
  return request({
    url: `/platform/${key}/allMenus`,
    method: 'get',
    params
  })
}
